
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass() 
    @Serenity.Decorators.panel()
    export class ECommExchangeDialog extends _Ext.TransDialog<ECommExchangeRow, any> {

        protected getFormKey() { return ECommExchangeForm.formKey; }
        protected getIdProperty() { return ECommExchangeRow.idProperty; }
        protected getLocalTextPrefix() { return ECommExchangeRow.localTextPrefix; }
        protected getNameProperty() { return ECommExchangeRow.nameProperty; }
        protected getService() { return ECommExchangeService.baseUrl; }
        protected getDeletePermission() { return ECommExchangeRow.deletePermission; }
        protected getInsertPermission() { return ECommExchangeRow.insertPermission; }
        protected getUpdatePermission() { return ECommExchangeRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new ECommExchangeForm(this.idPrefix);
        statement: string;
        contractTotals: string;
        TaxArray: any[];
        public Closing: boolean;
        //ProdctImage of Items
        public image: string;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            //q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //q.setGridEditorHeight(this.form.TaxDetails, 150);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            //q.hideCaption(this.form.Posted);

            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });


            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {

                //    let PartyDetails = OMS.VendorRow.getLookup().itemById[this.form.PartyId.value];
                this.form.ItemDetails.PartyId = parseInt(this.form.POSCustomerId.value);
            });
            //    this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
            //    this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
            //    this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
            //    this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
            //    //this.form.City.value = PartyDetails.City;
            //    this.form.GstVat.value = PartyDetails.GstVat;
            //    let AddressDetails = OMS.AddressMasterRow.getLookup().items.filter(x => x.LedgerId == parseInt(this.form.PartyId.value))[0];
            //    if (AddressDetails != null) {
            //        this.form.State.value = OMS.StatesMasterRow.getLookup().itemById[AddressDetails.State].StateName;
            //        this.form.Country.value = OMS.CountriesMasterRow.getLookup().itemById[AddressDetails.Country].Name;

            //        var city = OMS.CitiesMasterRow.getLookup().itemById[AddressDetails.City].Name;
            //        let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
            //            + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
            //        this.form.Address1.value = address;

            //    }


            //});
            //For RM Setup
            //this.form.BaseItemTypeId.changeSelect2(e => {
            //    this.form.ItemDetails.ProductTypeId = parseInt(this.form.BaseItemTypeId.value);
            //    OMS.ProductSelectGrid.ItemType = parseInt(this.form.BaseItemTypeId.value);
            //    var cols = this.form.ItemDetails.slickGrid.getColumns();
            //    if (parseInt(this.form.BaseItemTypeId.value) == 2) {
            //        cols = cols.filter(x => x.field != "SKU");
            //        cols = cols.filter(x => x.field != "Line_No");
            //        cols = cols.filter(x => x.field != "DiamondWeight");
            //        cols = cols.filter(x => x.field != "StoneWeight");
            //        cols = cols.filter(x => x.field != "OtherWeight");
            //        cols = cols.filter(x => x.field != "UnitLabour");
            //        cols = cols.filter(x => x.field != "NetWeight");
            //        cols = cols.filter(x => x.field != "WstWt");
            //        cols = cols.filter(x => x.field != "WstPer");
            //        this.form.ItemDetails.slickGrid.setColumns(cols);
            //    } else {
            //        this.form.ItemDetails.slickGrid.setColumns(cols);
            //    }
            //}); 
            this.form.CurrencyId.changeSelect2(e => {
                var ECommExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ECommExchangeDetails.ExchRate;
            });

            //this.form.DepartmentId.changeSelect2(e => {
            //    this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            //});

            q.setTextRightAlign(this.form.RoundOff);
            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
            });
            //Load Image after Row in Details is Clicked
            var _this = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {
                var self = this;
                var x: Serenity.UploadedFile = {
                    Filename: self.form.ItemDetails.image,
                    OriginalName: ""
                }
                _this.form.ProductItemImage.value = x;//ECommSalesDialog.image;

                //Set Image Width & Height

                q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            });
            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getItems().length;


                this.CalculateAmountandTax(Items, TotalItems);

            });

        }

        onDialogClose() {
            this.Closing = true;

        }

        private CalculateAmountandTax(Items: any,   TotalItems: number) {

            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < codearray.length; i++) {
                    if (codearray[i] == x.HSN) {
                        amtarray[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    codearray.push(x.HSN);
                    amtarray.push(x.GrossAmount);
                } 
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;
             

            this.form.TaxAmount.value = TaxAmount;
            this.form.GrossAmount.value = gramt + TaxAmount;
            this.form.Pieces.value = pcs;
            this.form.Weight.value = wt;
            this.form.NetWeight.value = nwt;
            //}
            //else {
            //    this.form.GrossAmount.value = gramt;
            //    this.form.Pieces.value = pcs;
            //    this.form.Weight.value = wt;
            //    this.form.NetWeight.value = nwt;

            //}


        }

        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var ECommExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ECommExchangeDetails.ExchRate;
            }  

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'ECommerce.ECommExchangeVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));
            


            var postingpermission = Q.Authorization.hasPermission('EComm:ECommExchange:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',

                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                    
                    ECommExchangeService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        } 
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                ECommExchangeService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        } 
    }
}